import { z } from 'zod';

export const stoCustomerEmailSchema = z.object({
  to: z.string().email(),
  // Optional explicit CC list. Omitted = PM is CC'd (legacy behavior); an
  // explicit array (including empty) is respected as-is so the PM's edit wins.
  cc: z.array(z.string().email()).max(10).optional(),
  subject: z.string().min(1).max(200),
  message: z.string().min(1).max(5000),
});

/** The prefilled, PM-editable default message for the STO customer email. */
export function buildStoCustomerDefaultMessage(input: {
  contactFirstName?: string;
  projectName: string;
  pmName?: string;
  pmEmail?: string;
}): string {
  const greeting = input.contactFirstName ? `Hi ${input.contactFirstName},` : 'Hi there,';
  const pmSentence = input.pmName
    ? `Your dedicated Project Manager is ${input.pmName}, who will be your main point of contact throughout the project and will reach out shortly to coordinate scheduling and next steps.`
    : `Your dedicated Project Manager will be your main point of contact throughout the project and will reach out shortly to coordinate scheduling and next steps.`;
  const contactLine =
    input.pmName && input.pmEmail
      ? `\n\nIf you have any questions in the meantime, please reach out to ${input.pmName} at ${input.pmEmail}.`
      : '';

  return `${greeting}

Thank you for choosing Harris Technology Services. Our team has completed the internal turnover for your project, ${input.projectName}, and we're excited to get started.

${pmSentence}${contactLine}

We look forward to working with you.

Best regards,
The HTS Team`;
}
